<template lang="pug">
#article 
  section-hero-alt(:title='t("pages.team.title")', image='team.jpg')
  section-people(:sections='peopleSections')
  section-info-alt
</template>

<script setup>
import { useRoute, useRuntimeConfig } from 'nuxt/app'
import { createPeopleSections, getAllPeople } from '~/services/peopleService'
import {
  createAbsoluteUrl,
  createPageSchemaContext,
  createSeoMeta,
} from '~/utils/schema'

defineOptions({
  name: 'Persons',
})

const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()
const { baseUrl, pageUrl } = createPageSchemaContext(
  route.path,
  runtimeConfig.public.baseUrl,
)
const description = t('seo.teamDescription')
const imageUrl = createAbsoluteUrl('/hero/team.jpg', baseUrl)

useSeoMeta(createSeoMeta(t('pages.team.title'), description, pageUrl, imageUrl))

const { data: peopleData } = await useAsyncData('people', () => getAllPeople())

const peopleSections = computed(() =>
  createPeopleSections(peopleData.value ?? []),
)
</script>
